export default __webpack_public_path__ + "static/media/wsjLogo.8313008c.svg";